export const removeAllDash = (v?: string) => v?.replace(/-/g, '');
